import { frontendURL } from '../../../../helper/URLHelper';

const kanban = accountId => ({
  parentNav: 'kanban',
  routes: [
    'kanban_board',
  ],
  menuItems: [],
});

export default kanban;
